// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2sQRK","alert":"SettungsInbox_alert__uQrXF"};